import { Box, Container, Grid, ListItem } from '@chakra-ui/react';
import { BoardMembers as BoardMembersProps } from '../../types';
import { SectionHeader } from '../BasicBlocks';
import OrderedList from '../OrderedList';
import PersonTeaser from '../PersonTeaser';
import FullWidthBlock from '../FullWidthBlock';

const BoardMembers = ({ title, members }: BoardMembersProps) => (
  <Box data-test-id="section-board-members">
    {title && <SectionHeader titleAs="h3" title={title} />}
    <FullWidthBlock>
      <Container maxW="container.lg">
        <Grid
          templateColumns="repeat(auto-fill, minmax(280px, 1fr))"
          gridColumnGap="6"
          gridRowGap={['6', '10']}
          alignItems="flex-start"
          mb="10"
          as={OrderedList}
        >
          {members.map((person) => (
            <PersonTeaser
              height="100%"
              key={`${person.id}-${person?.surname?.replace(/\s/g, '-')}`}
              {...person}
              as={ListItem}
              boardMember
            />
          ))}
        </Grid>
      </Container>
    </FullWidthBlock>
  </Box>
);

export default BoardMembers;
